module.exports = __webpack_public_path__ + "static/img/shrcb.e45f64f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/shrcb.png
// module id = fBmO
// module chunks = 93